import { tViews } from "../../../../../utils/table";

export default {
  get title() { return tViews('appViewApplication'); },
  theme: "quality",
  text: {
    good: {
      get title() { return tViews('appQoeDonutGood'); },
      get tooltip() { return tViews('applicationOverviewLabelGood'); }
    },
    fair: {
      get title() { return tViews('appQoeDonutFair'); },
      get tooltip() { return tViews('applicationOverviewLabelFair'); }
    },
    bad: {
      get title() { return tViews('appQoeDonutPoor'); },
      get tooltip() { return tViews('applicationOverviewLabelPoor'); }
    },
    unknown: {
      get title() { return tViews('appQoeDGray'); },
      get tooltip() { return tViews('applicationOverviewLabelGray'); }
    }
  }
};
